// extracted by mini-css-extract-plugin
export default {"Content":"FiveNinety_Content__ooPJs","MetadataSection":"FiveNinety_MetadataSection__J7TbI"};